import React from 'react';
import { Text } from 'pounceV2';

const AlertSettingsFieldTitleV3: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <Text variant="body/lg" fontWeight="medium" pb={1}>
    {children}
  </Text>
);

export default AlertSettingsFieldTitleV3;
